"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const react_1 = __importDefault(require("react"));
const Card_styles_1 = require("./Card.styles");
const renderCardHeader = ({ header, spacing, backgroundColour, }) => {
    if (!header) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Card_styles_1.StyledCardHeader, { spacing: spacing, backgroundColour: backgroundColour }, header),
        react_1.default.createElement(Card_styles_1.StyledCardLineBreak, null)));
};
const renderCardFooter = ({ footer, spacing }) => {
    if (!footer) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Card_styles_1.StyledCardLineBreak, null),
        react_1.default.createElement(Card_styles_1.StyledCardFooter, { spacing: spacing }, footer)));
};
/**
 * @deprecated please use <Ds.Card> instead
 * @see https://storybook.accurx.com/?path=/docs/migrated-components-card-migration-examples--docs
 */
const Card = ({ className, as, spacing = 3, spacingBody, variant = "regular", children, props, header, footer, isElevated = true, headerBackgroundColour, }) => {
    return (react_1.default.createElement(Card_styles_1.StyledCard, Object.assign({ className: className, as: as, variant: variant, isElevated: isElevated }, props),
        renderCardHeader({
            spacing,
            header,
            backgroundColour: headerBackgroundColour,
        }),
        react_1.default.createElement(Card_styles_1.StyledCardBody, { spacing: spacingBody !== null && spacingBody !== void 0 ? spacingBody : spacing }, children),
        renderCardFooter({ spacing, footer })));
};
exports.Card = Card;
//# sourceMappingURL=Card.js.map